import DetailsAndOperationsTab from './DetailsAndOperationsTab';

export default DetailsAndOperationsTab;